import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { Tag } from 'antd';
import { DeleteOutlined, UndoOutlined } from '@ant-design/icons';
import fetchUsers from '../../../services/apollo/func/fetch/fetchUsers';
import handleDeleteUser from '../../../services/apollo/func/handle/handleDeleleUser';
import handleRestoreUser from '../../../services/apollo/func/handle/handleRestoreUser';
import auth from '../../../utils/auth';
import { formatPascalCase } from '../../../utils/index';
import NormalButton from '../../components/buttons/normalButton';

export const formatUsers = users => users.map(user => ({
  key: user.id,
  id: user.id,
  username: `${user?.firstName || '--'} ${user?.lastName || '--'}`,
  role: user?.roles ? formatPascalCase(user.roles[0]) : '--',
  email: user?.email || '--',
  createdAt: user?.createdAt ? moment(user.createdAt).format('DD/MM/YYYY - HH:mm:ss') : '--',
  createdBy: user?.createdBy ? `${user?.createdBy?.firstName || '--'} ${user?.createdBy?.lastName || '--'}` : '--',
  isDeleted: Boolean(user?.deletedAt),
}));

export const getSearchBy = () => {
  const searchBy = [
    {
      label: 'username',
      value: 'name',
    },
  ];
  return searchBy;
};
export const getColumns = (onDeleteClick, onRestoreClick) => {
  const columns = [
    {
      title: 'Username',
      dataIndex: 'username',
      key: 'username',
    },
    {
      title: 'Email address',
      dataIndex: 'email',
      key: 'email',
      render: (email, record) => (
        <>
          {email}
          {record.isDeleted && <Tag color="red" className="ml-8">Deleted</Tag>}
        </>
      ),
    },
    {
      title: 'Role',
      dataIndex: 'role',
      key: 'role',
    },
    {
      title: 'Created on',
      dataIndex: 'createdAt',
      key: 'createdAt',
    },
    {
      title: 'Created by',
      dataIndex: 'createdBy',
      key: 'createdBy',
    },
  ];
  if (auth.isAdmin()) {
    columns.push({
      title: '',
      dataIndex: 'actions',
      key: 'actions',
      render: (_value, record) => (
        record.isDeleted ? (
          <NormalButton
            icon={<UndoOutlined />}
            onClick={(e) => {
              e.stopPropagation();
              onRestoreClick(record);
            }}
          />
        ) : (
          <NormalButton
            isDanger
            icon={<DeleteOutlined />}
            onClick={(e) => {
              e.stopPropagation();
              onDeleteClick(record);
            }}
          />
        )
      ),
    });
  }
  return columns;
};


export const deleteUser = async (userId) => {
  try {
    const delUser = await handleDeleteUser({ userId });
    return delUser;
  } catch (error) {
    return {
      isSuccess: false,
      message: error.message,
    };
  }
};

const RESTORE_FAILURE_MESSAGE = "Couldn't restore this user. Please try again or contact engineering.";

export const restoreUser = async (userId) => {
  try {
    const result = await handleRestoreUser({ userId });
    if (!result?.isSuccess) {
      return { isSuccess: false, message: result?.message || RESTORE_FAILURE_MESSAGE };
    }
    return result;
  } catch (error) {
    return {
      isSuccess: false,
      message: error.message || RESTORE_FAILURE_MESSAGE,
    };
  }
};

export const handleFetchUsers = async (filter, limit) => {
  try {
    const thisFilter = {
      roles: ['ADMIN', 'POWER_USER', 'LIGHT_USER'],
      includeDeleted: false,
    };
    Object.assign(thisFilter, filter);
    const me = auth.getLoginData();
    const users = await fetchUsers({ filter: thisFilter, limit });
    if (!_.isEmpty(users)) {
      return formatUsers(users.filter(user => user.id !== me.id));
    }
    return [];
  } catch (error) {
    return [];
  }
};
